class DumbJs {
  bindall() {
    let currentClass = null;

    // Isn't javascript a piece of shit? :)
    // Auto-binding every method and extending with concerns
    while(currentClass != DumbJs) {
      currentClass = currentClass ? Object.getPrototypeOf(currentClass) : Object.getPrototypeOf(this.constructor);

      Object.getOwnPropertyNames(currentClass.prototype).forEach((propertyName) => {
        if(typeof this[propertyName] == 'function' && propertyName != 'constructor') {
          this[propertyName] = this[propertyName].bind(this);
        }
      });

      if (currentClass.concerns) {
        currentClass.concerns.forEach((concern) => {
          Object.getOwnPropertyNames(concern).forEach((propertyName) => {
            if(!this[propertyName] && typeof concern[propertyName] == 'function') {
              this[propertyName] = concern[propertyName].bind(this);
            }
          });
        })
      }
    }
  }
}

class OpenWith extends DumbJs {
  constructor(...args) {
    super(...args);
    this.bindall()
  }

  setup() {
    if(!isCordova) return

    cordova.openwith.init(this.initSuccess, this.initError)
    cordova.openwith.addHandler(this.handler)
  }

  initSuccess() {
    console.log("this", this);
  }

  initError() {
  }

  handler(intent) {
    console.log('intent received');

    console.log('  action: ' + intent.action); // type of action requested by the user
    console.log('  exit: ' + intent.exit); // if true, you should exit the app after processing

    for (var i = 0; i < intent.items.length; ++i) {
      var item = intent.items[i];
      console.log('  type: ', item.type);   // mime type
      console.log('  uri:  ', item.uri);     // uri to the file, probably NOT a web uri

      // some optional additional info
      console.log('  text: ', item.text);   // text to share alongside the item, iOS only
      console.log('  name: ', item.name);   // suggested name of the image, iOS 11+ only
      console.log('  utis: ', item.utis);
      console.log('  path: ', item.path);   // path on the device, generally undefined
    }

    window.currentIntent = intent
    window.location = 'https://localhost/index.html#/dodones/today?tab=proofs'
  }
}

export default new OpenWith
